<template lang="pug">
div(:class="{'in-uploader':isPhotoStudio}").wrap-item-change-pose
  div.wrap-window
    div.wrap-tab-header.pt12.py12.px12
      div.tab-header.f.flex-between
        div(v-for="tab in tabs"
          @click="currentTab = tab"
          :class="{'active': currentTab == tab}").tab.f.fh.py6.cursor-pointer
          span.fz12 {{tab}}
    div.wrap-changer
      div(v-show="currentTab == '感情'").wrap-blend-shape-changer.changer.px12.pb10
        div(v-for="blendShape in blendShapesProps"
          v-if="blendShapeNames.includes(blendShape.name)").mb4.pl4
          span.label.block.fz14 {{blendShape.label}}
          v-slider(v-model="blendShape.value"
            min="0.0" max="1.0" step="0.05" dark)
      div(v-show="currentTab == '視線'").wrap-look-at-changer.changer.px12.pb40
        AtomEyesBoneChanger(@updateEyesBone="updateEyesBone"
          :currentLeftEyeBone="currentLeftEyeBone"
          :currentRightEyeBone="currentRightEyeBone"
          :targetObject="targetObject")
      div(v-show="currentTab == 'テクスチャ'").wrap-texture-changer.changer.px12.pb40
        div.mb12
          v-checkbox(v-model="isHidingEyes" label="のっぺらぼう" dark)
        AtomExpressionTextureChanger(
          :isPhotoStudio="isPhotoStudio" :clock="clock"
          :targetObject="targetObject" :targetObjectDoc="targetObjectDoc"
          @addCustomTextureToVRM="addCustomTextureToVRM"
          @removeCustomTextureFromVRM="removeCustomTextureFromVRM"
          @updateObjectDoc="updateObjectDoc")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$header_tab_area_height: 104px;
$sub_tab_height: 54px;
.wrap-item-change-pose {
  position: relative;
  max-height: calc(#{$device_height} - (#{$studio_basic_margin} * 2) - #{$header_tab_area_height});
  &.in-uploader {
    height: 100%;
    .wrap-changer {
      height: calc(100% - #{$sub_tab_height});
    }
  }
  .wrap-window {
    position: relative;
    width: 80vw; height: 100%;
    max-width: $studio_window_max_width;
    .wrap-tab-header {
      width: 100%;
      .tab-header {
        background: $secondary_active_color;
        border-radius: 18px;
        color: $dark_primary_text_color;
        overflow: hidden;
        .tab {
          width: 100%;
          &.active {
            background: $active_color;
          }
        }
      }
    }
    .label {
      color: $dark_primary_text_color;
    }
    .wrap-changer {
      position: relative;
      max-height: calc(#{$device_height} - (#{$studio_basic_margin} * 2) - #{$header_tab_area_height} - #{$sub_tab_height});
      overflow: scroll;
      .changer {
        width: 100%;
        // max-height: calc(55vh - #{$header_tab_area_height});
        // overflow: scroll;      
        scrollbar-width: none;
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      .changer::-webkit-scrollbar {
        display:none;
      }
    }
  } // .wrap-window
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-item-change-pose {
  .v-messages {
    display: none;
  }
  .v-input--selection-controls {
    margin: 0;
  }
}
</style>

<script>
import { eyesBones, blendShapes } from '@/plugins/vrm-nums'
import vrmManager from '@/components/mixin/vrmManager'
import AtomEyesBoneChanger from '@/components/atom/studio/AtomEyesBoneChanger'
import AtomExpressionTextureChanger from '@/components/atom/studio/AtomExpressionTextureChanger'

export default {
  mixins: [vrmManager],
  components: {
    AtomEyesBoneChanger, AtomExpressionTextureChanger
  },
  props: {
    targetObject: {
      type: Object,
      required: true
    },
    objects: {
      type: Array,
      required: false
    },
    clock: {
      type: Object,
      required: true
    },
    isPhotoStudio: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      currentTab: '感情',
      tabs: ['感情', '視線', 'テクスチャ'],
      eyesBoneProps: [],
      blendShapesProps: [],
      currentBlendShape: null,
      preventBonesUpdateByWatch: true, preventBlendShapesUpdateByWatch: true,
      isHidingEyes: false
    }
  },
  computed: {
    targetObjectDoc () {
      if (!this.isPhotoStudio) {
        const docId = this.targetObject.userData.docId
        return this.objects.filter(o => o.id === docId)[0]
      } else {
        return null
      }
    },
    vrm () {
      return this.targetObject.userData.vrm
    },
    eyesBones () {
      return eyesBones
    },
    blendShapes () {
      return blendShapes
    },
    blendShapeNames () {
      return blendShapes.map(blendShape => blendShape.name)
    },
    currentLeftEyeBone () {
      return this.eyesBoneProps.filter(bone => {
        return ['LeftEye'].includes(bone.name)
      })[0]
    },
    currentRightEyeBone () {
      return this.eyesBoneProps.filter(bone => {
        return ['RightEye'].includes(bone.name)
      })[0]
    }
  },
  watch: {
    // bonesProps: {
    //   handler () {
    //     if (this.preventBonesUpdateByWatch) {
    //       this.preventBonesUpdateByWatch = false
    //       return
    //     }
    //     this.$emit('updateBoneProp', this.bonesProps)
    //   },
    //   deep: true
    // },
    eyesBoneProps: {
      handler () {
        if (this.preventBonesUpdateByWatch) {
          this.preventBonesUpdateByWatch = false
          return
        }
        this.$emit('updateEyesBoneProp', this.eyesBoneProps)
      },
      deep: true
    },
    blendShapesProps: {
      handler () {
        if (this.preventBlendShapesUpdateByWatch) {
          this.preventBlendShapesUpdateByWatch = false
          return
        }
        this.$emit('updateBlendShapeProp', this.blendShapesProps)
      },
      deep: true
    },
    targetObject (currentObject, previousObject) {
      if (previousObject && previousObject.uuid !== currentObject.uuid) {
        this.initialize()
      }
    },
    async isHidingEyes () {
      const delta = this.clock.getDelta()
      if (this.isHidingEyes) {
        await this.hideEyes({ vrm: this.vrm, delta })
      } else {
        await this.showEyes({ vrm: this.vrm, delta })
      }
      this.$emit('updateObjectDoc', {
        docId: this.targetObject.userData.docId,
        fieldName: 'isHidingEyes',
        fieldValue: this.isHidingEyes
      })
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      // if (this.targetObject && this.targetObject.userData.vrm) {
      if (!this.isPhotoStudio) {
        // スタジオインターフェースで特定のキャラクターが選択された場合
        this.preventBonesUpdateByWatch = true
        this.preventBlendShapesUpdateByWatch = true

        const docId = this.targetObject.userData.docId
        const objectDoc = this.objects.filter(o => o.id === docId)[0]
        this.eyesBoneProps = objectDoc.pose.filter(bone => {
          return ['LeftEye', 'RightEye'].includes(bone.name)
        })
        // vrm-numのBlinkの値をミスっていたころのデータに対応
        // this.blendShapesProps = objectDoc.blendShape.map((b, index) => {
        //   return {
        //     ...b, // index,
        //     label: this.blendShapes
        //       .filter(blendShape => blendShape.name === b.name)[0].label
        //   }
        // })
        
        let blendShapesNamesV1 = this.blendShapes.map(b => b.name)
        let blendShapesNamesV0 = this.blendShapes.map(b => b.nameV0)
        const allBlendShapesNames = blendShapesNamesV1.concat(blendShapesNamesV0)
        this.blendShapesProps = objectDoc.blendShape
          // .filter(b => !['BlinkLeft', 'BlinkRight'].includes(b.name))
          .filter(b => !['BlinkL', 'BlinkR'].includes(b.name)) // vrm v0
          .filter(b => allBlendShapesNames.includes(b.name))
          .map((b, index) => {
            let expression = this.blendShapes
              .filter(blendShape => b.name === blendShape.name)[0]
            if (!expression) {
              expression = this.blendShapes
                .filter(blendShape => b.name === blendShape.nameV0)[0]
            }            
            return {
              ...b, // index,
              label: expression.label
            }
          })
        
        if (objectDoc.isHidingEyes) this.isHidingEyes = objectDoc.isHidingEyes
      } else {
        // 新規でvrmがaddされていた場合
        this.eyesBoneProps = this.eyesBones.map(bone => {
          return {
            ...bone,
            rotation: { x: 0.0, y: 0.0, z: 0.0 }
          }
        })
        
        this.blendShapesProps = this.blendShapes.map((blendShape, index) => {
          return { 
            ...blendShape,
            value: 0.0, 
          }
        })
        this.currentBlendShape = this.blendShapesProps[0]
        // this.$emit('updateBoneProp', this.bonesProps)
      }
    },
    updateEyesBone ({ x, y, z=0 }) {
      // this.bonesProps = this.bonesProps.map(bone => {
      //   if (['LeftEye', 'RightEye'].includes(bone.name)) {
      //     bone.rotation.x = x
      //     bone.rotation.y = y
      //     bone.rotation.z = z
      //   }
      //   return bone
      // })
      this.eyesBoneProps = this.eyesBoneProps.map(bone => {
        bone.rotation.x = x
        bone.rotation.y = y
        bone.rotation.z = z
        return bone
      })
    },
    // for texture
    addCustomTextureToVRM ({ vrm, delta, addingTextureName }) {
      this.$emit('addCustomTextureToVRM', { vrm, delta, addingTextureName })
    },
    removeCustomTextureFromVRM ({ vrm, delta, removingTextureName }) {
      this.$emit('removeCustomTextureFromVRM', { vrm, delta, removingTextureName })
    },
    // common
    updateObjectDoc (params) {
      this.$emit('updateObjectDoc', params)
    }
  }
}
</script>
